enum Location {
  ARTICLE = 'article',
  DASHBOARD_HEADER = 'dashboard_header',
  DASHBOARD_FOOTER = 'dashboard_footer',
  DASHBOARD = 'dashboard',
  DOCUMENT_INTERACTION_MODAL = 'document_interaction_modal',
  EASTER = 'easter',
  EQUIPMENT = 'equipment browse',
  GUIDE = 'guide',
  CARD_AD = 'card ad',
  CANCEL_SURVEY = 'Cancel Survey',
  CLASSES_DASHBOARD = 'classes_dashboard',
  CLASSES_DASHBOARD_CAROUSEL_CARD = 'classes_dashboard_carousel_card',
  CLASSES_DASHBOARD_FOOTER = 'classes_dashboard_footer',
  CLASSES_FAVORITES = 'classes_favorites',
  CLASS_OVERVIEW = 'class_overview',
  CLASS_OVERVIEW_ABOUT = 'class_overview_about',
  CLASS_OVERVIEW_CONTENTS = 'class_overview_contents',
  CLASS_OVERVIEW_FAQ = 'class_overview_FAQ',
  CLASS_OVERVIEW_FOOTER = 'class_overview_footer',
  CLASS_OVERVIEW_HEADER = 'class_overview_header',
  CLASS_OVERVIEW_INSTRUCTORS = 'class_overview_instructors',
  COMMENTS = 'comments',
  COMMENTS_SEARCH = 'comments search',
  COMMENTS_SCREEN = 'comments_screen',
  DOCUMENT_PAYWALL = 'document_detail_paywall',
  FAVORITES_CARD = 'Favorites Carousel',
  FAVORITES = 'favorites',
  HOLIDAY = 'holiday',
  HOMEPAGE = 'homepage',
  HOMEPAGE_CAROUSEL_CARD = 'homepage_carousel_card',
  HOMEPAGE_FILTER_CAROUSEL_CARD = 'homepage_filter_carousel_card',
  HOMEPAGE_CAROUSEL = 'homepage_carousel',
  HOMEPAGE_COLLECTION_CAROUSEL = 'homepage_collection_carousel',
  HOMEPAGE_FILTER_CAROUSEL = 'homepage_filter_carousel',
  HOMEPAGE_HERO = 'homepage_hero',
  HOMEPAGE_RECENTLY_FAVORITED_CARD = 'homepage_recently_favorited_card',
  HOMEPAGE_FAVORITES_CAROUSEL_CARD = 'homepage_favorites_carousel_card',
  HOMEPAGE_FEATURED_CAROUSEL = 'homepage_featured_carousel',
  HOMEPAGE_FAVORITES_CAROUSEL = 'homepage_favorites_carousel',
  INGREDIENTS = 'ingredients browse',
  INSTRUCTOR_MODAL = 'instructor_modal',
  LEARN = 'learn browse',
  LESSON = 'lesson',
  LESSON_EQUIPMENT = 'lesson_equipment',
  LESSON_FAQ = 'lesson_faq',
  LESSON_FOOTER = 'lesson_footer',
  LESSON_HEADER = 'lesson_header',
  LESSON_STEP = 'lesson_step',
  LESSON_STEP_FOOTER = 'lesson_step_footer',
  LESSON_STEP_HEADER = 'lesson_step_header',
  LESSON_UP_NEXT = 'lesson_up_next',
  MAGAZINES = 'Magazine Browse All',
  MAGAZINE_BROWSE = 'Magazine Browse',
  MAGAZINE_ISSUE_BROWSE = 'Magazine Issue Browse',
  ONBOARDING = 'Onboarding',
  REVIEW_DETAIL = 'review detail',
  PURCHASE_SCREEN = 'purchase_screen',
  RECIPE_DETAIL = 'recipe detail',
  RECIPE_LESSON = 'recipe_lesson',
  RECIPE_BROWSE = 'recipe-browse',
  RECIPE_COLLECTION = 'recipe-collection',
  SETTINGS = 'settings',
  SETTINGS_ACCOUNT = 'Settings - My Account Screen',
  SETTINGS_PREFERENCES = 'Settings - My Preferences Screen',
  SUPERBOWL = 'superbowl',
  THANKSGIVING = 'thanksgiving',
  BOOKS = 'collections-books',
  BOOK_DETAIL = 'collections-book-detail',
  OCCASION_DETAIL = 'occasion-detail',
  MY_STUFF_CAROUSEL_CARD = 'my_stuff_carousel_card',
  WATCH_BROWSE = 'watch browse',
  USER_PAGE = 'user_page',
  UPDATE_PROFILE = 'update_profile',
  SAVE_OFFER_PAGE = 'offer page',
  ONLINE_COOKING_SCHOOL = 'online_cooking_school',
  COOKED_RECIPES = 'cooked_recipes',
  FAVORITE_COLLECTION = 'favorite_collection',
  MY_COLLECTIONS = 'my_collections',
  VOUCHERS = 'Vouchers',
}

export default Location;
